<template>
    <div :style="topStyle" :class="classes">
        <slot :content-style="contentStyle" />
    </div>
</template>

<script>
    import debounce from 'lodash/debounce';
    import Responsive from '../mixins/responsive';

    export default {
        mixins:[Responsive],
        props: {
            // static: Boolean,
            minimal: Boolean,
            collapseUnder: Number,
        },
        data() {
            return {
                collapsed: false,
                collapsedHeight: 0,
                defaultHeight: 0,
                stickyEnabled: true,
                viewportWidth: window.innerWidth,

                rightOffset: 0, // on bootstrap modal open
            }
        },
        computed: {
            classes() {
                return {
                    'ready': true,
                    'collapsed': this.collapsed,
                }
            },
            topStyle() {
                const height = this.isMinimal ? this.collapsedHeight : this.defaultHeight;
                return {
                    paddingTop: this.collapsed ? `${height}px` : '0',
                }
            },
            isMinimal() {
                return this.collapseUnder
                    ? this.viewportWidth < this.collapseUnder
                    : !!this.minimal
            },
            contentStyle() {
                return {
                    right: this.rightOffset,
                }
            },
            collapsingY() {
                let diff = this.defaultHeight - this.collapsedHeight;
                return diff<1 ? 1 : diff;
            },
        },
        methods: {
            update() {
                this.collapsed = this.isMinimal || this.stickyEnabled && window.pageYOffset > this.collapsingY;
            },
            layout() {
                let content = this.$el.querySelector('.header-content');
                let oldClass = this.$el.className;
                this.$el.classList.add('collapsed');
                this.collapsedHeight = content.offsetHeight;
                this.$el.classList.remove('collapsed');
                this.defaultHeight = content.offsetHeight;
                this.$el.className = oldClass;
            },
            handleResize() {
                if(window.innerWidth === this.viewportWidth) {
                    return;
                }
                this.viewportWidth = window.innerWidth;
                this.layout();
                this.update();
            },
            handleScroll() {
                this.update();
            },
        },
        mounted() {
            this.handleResize = debounce(this.handleResize, 200);

            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);

            this.layout();
            this.$nextTick(this.update);

            this.$root.$on('header::disable-sticky', disabled => {
                if(window.innerWidth < this.breakpoints.md) {
                    this.stickyEnabled = !disabled;
                    if(!this.stickyEnabled) {
                        window.scrollTo(0,0);
                    }
                    this.update();
                }
            });

            // handle body padding right on modal open (bootstrap scrollbar fix)
            if('MutationObserver' in window) {
                new MutationObserver(() => {
                    this.rightOffset = document.body.hasAttribute('data-padding-right')
                        ? document.body.style.paddingRight
                        : 0;
                }).observe(document.body, { attributes:true });
            }

            if('ResizeObserver' in window) {
                const content = this.$el.querySelector('.header-content');
                new ResizeObserver(() => {
                    document.documentElement.style.setProperty('--header-height', `${content.offsetHeight}px`);
                }).observe(content);
            }
        },
        destroyed() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize)
        }
    }
</script>
